module.exports = __webpack_public_path__ + "img/sales-representative.6b410c35.png";